import { PermissionsType } from '@/common/permissionsConst';
import ConfigOperationRecord from './ConfigOperationRecord';
import LoadDispatchCenter from './index';
import LoadDispatchModeConfig from './ModeConfig';
import LoadDispatchOperationRecord from './OperationRecord';

const routes = [
  {
    path: '/dispatch/control/load-center',
    permission: PermissionsType.P_LOAD_DISPATCH_CENTER,
    element: <LoadDispatchCenter />,
  },
  {
    path: '/dispatch/controlLoadCenter/operation-record',
    permission: PermissionsType.P_REGULATION_MODE_OPERATION_RECORD,
    element: <ConfigOperationRecord />,
  },
  {
    path: '/dispatch/control/load-center/mode-config',
    element: <LoadDispatchModeConfig />,
  },
  {
    path: '/dispatch/control/load-center/operation-record',
    element: <LoadDispatchOperationRecord />,
  },
];

export default routes;
